import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
} from 'vue-router';

import { scrollBehavior, layoutClient, Header, Sidebar, Navigation, NavigationBar } from '@ozdao/martyrs/modules/core/client';

// Хедер лендинга — своя стеклянная капсула, а не martyrs Header с обёрткой.
import DobroHeader from '@/components/partials/DobroHeader.vue';

const isServer = typeof window === 'undefined';

const history = isServer ? createMemoryHistory() : createWebHistory();

// Имя 'Home' у корневого роута обязательно: core.app.js вешает на него
// заглушки backoffice/organizations/users через router.addRoute('Home', ...).
const routes = [{
  path: '/:locale?',

  components: {
    default: layoutClient
  },

  name: 'Home',

  meta: {
    header: Header,
    sidebar: Sidebar,
    sidebar_navigation: Navigation,
    navigationbar: NavigationBar,
  },

  children: [{
    path: '',
    name: 'Index',
    meta: {
      header: DobroHeader,
      sidebar: null,
      hideNavigationBar: true,
      title: {
        en: 'Home',
        ru: 'Главная'
      },
    },
    component: () => import('@/components/pages/Home.vue'),
  }]
}];

export function getRouter() {
  return createRouter({
    routes,
    history,
    scrollBehavior
  });
}
